import React from "react";
import type { FC } from "react";

import { Counter } from "../../../Counter/Counter";

import type { ExcludeCustomView } from "../../../../types/react";
import type { CounterProps } from "../../../Counter";

const BUTTON_INLINE_COUNTER_TEST_ID = "button-inline-counter";

interface IButtonInlineCounterMain extends Pick<CounterProps, "size"> {}

type ButtonInlineCounter = Pick<CounterProps, "quantity">;

export const ButtonInlineCounter: FC<ButtonInlineCounter> = (props) => {
    const { ...restProps } = props as ButtonInlineCounter &
        IButtonInlineCounterMain &
        ExcludeCustomView<CounterProps>;

    return (
        <Counter
            {...restProps}
            view="primary"
            stroke
            data-tsid={BUTTON_INLINE_COUNTER_TEST_ID}
        />
    );
};

ButtonInlineCounter.displayName = "ButtonInline.Counter";

export default ButtonInlineCounter;
